import http from "../../common/services/httpService";
import {Api, apiUrls} from "../../helpers/api";
import {
    CopySelectedWeekData,
    ModifyTimetableActionModel,
    NewTimetableActionsModel,
    NumberOfWeeksModel,
    TimetableActionModel,
    TimetableFileFormat,
    TimetableModel,
    WeekAndYearModel
} from "../models/timetable";
import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../../common/models/httpError";
import {format} from "date-fns";

export class TimetableService {
    public static async addAction(data: NewTimetableActionsModel): Promise<AxiosResponse<HttpErrorModel[] | any>> {
        return await http.post(Api.getUrl(apiUrls.timetables.timetables), data);
    }

    public static async getSelectedWeek(year: number, weekNumber: number): Promise<AxiosResponse<TimetableModel>> {
        return await http.get<TimetableModel>(`${Api.getUrl(apiUrls.timetables.timetables)}?year=${year}&week=${weekNumber}`);
    }

    public static async getCurrentDate(): Promise<AxiosResponse<WeekAndYearModel>> {
        return await http.get<WeekAndYearModel>(Api.getUrl(apiUrls.timetables.currentWeek));
    }

    public static async getNumberOfWeeks(year: number): Promise<AxiosResponse<NumberOfWeeksModel>> {
        return await http.get<NumberOfWeeksModel>(`${Api.getUrl(apiUrls.timetables.numberOfWeeks)}?year=${year}`);
    }

    private static localDateFormat = "yyyy-MM-dd";

    public static async download(from: Date, to: Date, fileFormat: TimetableFileFormat) {
        let mediaType, downloadProperUrl;
        if (fileFormat === TimetableFileFormat.json) {
            mediaType = "application/json";
            downloadProperUrl = apiUrls.timetables.downloadJson;
        } else {
            mediaType = "application/xls";
            downloadProperUrl = apiUrls.timetables.downloadXls;
        }

        return http.get<string>(`${Api.getUrl(downloadProperUrl)}?from=${format(from, this.localDateFormat)}&to=${format(to, this.localDateFormat)}`, {
            headers: {
                accept: mediaType
            },
            responseType: "blob"
        });
    }

    public static async copySelectedWeek(data: CopySelectedWeekData): Promise<AxiosResponse<HttpErrorModel[] | any>> {
        const url = Api.getUrl(apiUrls.timetables.copy);
        const params = `yearTo=${data.yearToCopy}&weekTo=${data.weekToCopy}&` +
            `yearFrom=${data.yearCopyFrom}&weekFrom=${data.weekCopyFrom}`;

        return await http.get<TimetableModel>(`${Api.addParams(url, params)}`);
    }

    public static async getAction(id: string): Promise<AxiosResponse<TimetableActionModel>> {
        return await http.get(`${Api.getUrl(apiUrls.timetables.timetables)}/${id}`);
    }

    public static async modifyAction(data: ModifyTimetableActionModel, id: string): Promise<AxiosResponse<HttpErrorModel[] | any>> {
        return await http.post(`${Api.getUrl(apiUrls.timetables.timetables)}/${id}`, data);
    }

    public static async removeAction(id: string): Promise<AxiosResponse<HttpErrorModel[] | any>> {
        return await http.delete(`${Api.getUrl(apiUrls.timetables.timetables)}/${id}`);
    }

    public static async cancelAction(id: string): Promise<AxiosResponse<HttpErrorModel[] | any>> {
        return await http.post(`${Api.getUrl(apiUrls.timetables.timetables)}/${id}/cancel`);
    }
}
